import React from "react";

function RehearsalspaceIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_899_1343)">
        <mask
          id="mask0_899_1343"
          style={{ maskType: "luminance" }}
          width="16"
          height="13"
          x="0"
          y="2"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#FEFEFE" d="M0 2h16v12.783H0V2z"></path>
        </mask>
        <g mask="url(#mask0_899_1343)">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M13.797 6.793h-1.546c-.32 0-.621.076-.896.206.015.132.04.259.04.394 0 .841-.32 1.603-.829 2.197h4.992c.245 0 .442-.21.442-.467 0-1.286-.985-2.33-2.203-2.33zM3.2 5.995A1.998 1.998 0 103.2 2c-1.105 0-2 .894-2 1.997 0 1.103.895 1.998 2 1.998zm1.398 1.398c0-.136.024-.266.04-.398-.273-.15-.573-.202-.89-.202H2.202C.986 6.793 0 7.838 0 9.123c0 .257.197.467.44.467h4.988a3.36 3.36 0 01-.83-2.197zM12.8 5.995A1.998 1.998 0 1012.8 2a1.998 1.998 0 100 3.995zm-3.552 4.793H6.753c-1.963 0-3.553 1.49-3.553 3.328 0 .37.318.667.71.667h8.18c.393 0 .71-.297.71-.667 0-1.838-1.59-3.328-3.552-3.328zm-1.25-.799a2.58 2.58 0 002.577-2.596c0-1.434-1.164-2.597-2.577-2.597A2.58 2.58 0 005.42 7.393c-.023 1.433 1.143 2.596 2.577 2.596z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_899_1343">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(RehearsalspaceIcon);
